<section class="error-section section-lg-space">
   <div class="container-fluid">
      <div class="row">
         <div class="col-xl-6 col-lg-7 m-auto">
            <div class="error-content">
               <img src="assets/svg/404.png" class="img-fluid blur-up lazyload" alt="page-not-found">
               <h2>{{ 'page_not_found' | translate }}</h2>
               <h3 class="text-content">
                  {{ 'page_not_found_text' | translate }}
               </h3>
               <a (click)="back()" class="btn btn-animation mt-4 mx-auto btn-md">{{ 'back_to_page' | translate }}</a>
            </div>
         </div>
      </div>
   </div>
</section>